var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"header_bottom"},[_c('div',{staticClass:"header_topinfo"},[_c('div',{staticClass:"header_menu"},[_c(_vm.CurrentNav,{tag:"component",attrs:{"navData":_vm.NavData}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }